import React from "react";
import { useAddEntity } from "../../../../../../utils/CustomFunctions";
import { FaSyncAlt } from "react-icons/fa";
import { Tooltip } from "antd";
import { Link, useParams } from "react-router-dom";

const AddAudiences = () => {
  const { id } = useParams();
  const server = process.env.REACT_APP_SERVER;
  const initialState = {
    name: "",
    icon: "",
  };

  // validate fields
  const validateFields = (values) => {
    let newErrors = {};

    if (!values.name) newErrors.name = "This value should not be null.";
    if (!values.icon) newErrors.icon = "This value should not be null.";
    return newErrors;
  };
  const {
    isPending,
    errors,
    newEntity,
    handleChange,
    handleIamgesChange,
    handleSubmit,
  } = useAddEntity(
    "admin",
    "audience",
    "audiences",
    initialState,
    validateFields,
    "/en/dashboard/administrator/manage-audiences"
  );

  return (
    <div className="card">
      <div className="card-body">
        <form className="signform" onSubmit={handleSubmit}>
          <div className="mb-4">
            <div className="mb-1">
              <label htmlFor="name" className="form-label fw-600">
                Name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                name="name"
                id="name"
                className="form-control"
                value={newEntity?.name}
                onChange={handleChange}
              />
            </div>
            {errors.name && (
              <small className="text-danger d-block">{errors.name}</small>
            )}
          </div>

          <div className="mb-4">
            <div className="mb-1">
              <label htmlFor="image" className="form-label fw-600">
                Image
              </label>
              <input
                type="file"
                name="icon"
                id="image"
                className="form-control"
                onChange={handleIamgesChange}
              />
            </div>
            {id && newEntity.icon && (
              <Tooltip title="Enlarge">
                <Link
                  className="fancybox"
                  to={`${server}/event/audience/${newEntity.icon}`}
                  target="_blank"
                >
                  <img
                    src={`${server}/event/audience/${newEntity.icon}`}
                    className="img-thumbnail re_ent_img"
                  />
                </Link>
              </Tooltip>
            )}
          </div>

          <div className="form-group mt-3 mb-3">
            <button
              className="btn btn-dark rounded-5"
              disabled={isPending ? "disabled" : ""}
              type="submit"
            >
              {isPending ? <FaSyncAlt className="spinIcon" /> : "save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAudiences;
